import { z } from 'zod';

// One-shot flags the onboarding pages pass to each other through
// `navigate(..., { state })` so the destination can tell "arriving back from
// the next step" apart from "arriving forward" (see each page's own comments
// on why the first paint differs). Router state is `unknown` by nature, so it
// is parsed here rather than cast at every read.
const onboardingNavigationStateSchema = z.object({
  fromAppLogoBack: z.boolean().optional(),
  fromTabBarBack: z.boolean().optional(),
  cameFromNotificationBack: z.boolean().optional(),
});

export type OnboardingNavigationState = z.infer<
  typeof onboardingNavigationStateSchema
>;

/** Anything that isn't a well-formed state object (null, a string, an
 * unknown flag type…) reads as "no flags set". */
export function readOnboardingNavigationState(
  state: unknown
): OnboardingNavigationState {
  const parsed = onboardingNavigationStateSchema.safeParse(state);
  return parsed.success ? parsed.data : {};
}
